import { $el, $elParent, whenDefined } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'
import { CarouselComponent } from './carousel'

const BUTTON_SELECTOR = '[data-carousel-play-button]'
const CAROUSEL_SELECTOR = 'carousel-component'

export class CarouselPlayButton extends BaseComponent {
  mountComponent(): void {
    this.update()
    this.addListener(this, 'click', this.handleButtonClick)

    if (this.carousel) {
      customElements.upgrade(this.carousel) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
      whenDefined('carousel-component').then(() => {
        this.carousel?.on('changePlayState', this.handleChangePlayState)
      })
    }
  }

  unmountComponent(): void {
    if (this.carousel) {
      whenDefined('carousel-component').then(() => {
        this.carousel?.off('changePlayState', this.handleChangePlayState)
      })
    }
  }

  handleChangePlayState = (): void => {
    this.update()
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.stopPropagation()

    if (!this.carousel) {
      return
    }

    if (!this.carousel.isPlay) {
      this.carousel.play()
    } else {
      this.carousel.stop()
    }

    this.resetAnimation()
  }

  update(): void {
    const button = $el(BUTTON_SELECTOR, this)

    if (!this.carousel || !button) {
      return
    }

    button.toggleAttribute('data-autoplay-stopped', !this.carousel.isPlay)
  }

  resetAnimation() {
    this.carousel.classList.toggle(
      'is-reset-autoplay-loader-animation',
      !this.carousel.isPlay,
    )
  }

  get carousel(): CarouselComponent {
    return $elParent(CAROUSEL_SELECTOR, this)
  }
}
